module.exports = __webpack_public_path__ + "media/images/features/modification/heading-refund-f239df8593ccac93112eaeb5a4448088.svg";